import axios from "axios";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

type ProjectStorageDeleteParams = Record<string, string | boolean | undefined>;

/**
 * Shared HTTP boundary for project-scoped object-storage deletion.
 * File-specific repositories continue to choose their route and metadata parameters.
 */
export const deleteProjectStorageFile = (requestHandler: IAuthenticatedRequestHandlerService, url: string, params: ProjectStorageDeleteParams): Promise<boolean> =>
  requestHandler.handleRequestAsync<boolean>(() => axios.delete<boolean>(url, { params }));
